import { put, takeLatest } from "redux-saga/effects";
import {
  fetchLocalTaskForceRolesRequest,
  fetchLocalTaskForceRolesSuccess,
  fetchLocalTaskForceRolesFailure,
} from "./localTaskForceRoleSlice";
import { fastApiURL } from "../../utils/config";

function* fetchLocalTaskForceRolesSaga() {
  try {
    const response = yield fetch(`${fastApiURL}/api/local-task-force-roles`);

    if (!response.ok) {
      throw new Error(`Failed to fetch LTF roles: ${response.status}`);
    }

    const data = yield response.json();

    const roles = data.map((role) => ({
      id: role.id,
      name: role.name,
      description: role.description
    }));

    yield put(fetchLocalTaskForceRolesSuccess(roles));
  } catch (error) {
    console.error("Error in fetchLocalTaskForceRolesSaga:", error);
    yield put(fetchLocalTaskForceRolesFailure(error.message));
  }
}

export function* watchLocalTaskForceRolesSaga() {
  yield takeLatest(
    fetchLocalTaskForceRolesRequest.type,
    fetchLocalTaskForceRolesSaga
  );
}